import links from "@/links/links";
import qs from "qs";

export default {
  actions: {
    GET_BY_MEETING(meetingId) {
      let params = {};
      if (meetingId) {
        params["meeting.id"] = meetingId;
      }
      return this.get(links.INVOICE_GET_BY_MEETING() + "?" + qs.stringify(params));
    },
  },
};
